import { render, staticRenderFns } from "./FormC.vue?vue&type=template&id=6d4c3ff4&scoped=true&"
import script from "./FormC.vue?vue&type=script&lang=js&"
export * from "./FormC.vue?vue&type=script&lang=js&"
import style0 from "./FormC.vue?vue&type=style&index=0&id=6d4c3ff4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c3ff4",
  null
  
)

export default component.exports